var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentView)?_c(_vm.currentView,{tag:"component",attrs:{"form-data":_vm.formData,"wizard-deps":_vm.wizardDependencies,"step-deps":_vm.currentStepDeps,"loading":_vm.loading},on:{"update":_vm.onUpdate}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }